var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#080A11",
    fillRule: "evenodd",
    d: "M12 0a3 3 0 0 1 3 3 3 3 0 0 1-1.032 2.26l6.403 12.806A3 3 0 0 0 21 18a3 3 0 1 1-2.902 3.75H5.902A2.999 2.999 0 0 1 0 21a3 3 0 0 1 3.628-2.934L10.03 5.26A3 3 0 0 1 9 3a3 3 0 0 1 3-3M3 19.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8m18 0a1.4 1.4 0 1 0 0 2.801 1.4 1.4 0 0 0 0-2.801M12.628 5.933a3 3 0 0 1-1.258 0L4.97 18.739l-.007-.006c.453.393.786.918.94 1.517h12.196a3 3 0 0 1 .949-1.525l-.017.014zM12 1.6A1.4 1.4 0 1 0 12 4.4 1.4 1.4 0 0 0 12 1.6",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSync;